import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '@progress/kendo-angular-layout';
import {PrettyJsonModule} from 'angular2-prettyjson';

import { MainRoutingModule, routableModules } from './main-routing.module';
import { MainComponent } from './main.component';
import { GrayBarHeaderModule } from '../common/component/gray_bar_header/gray_bar_header.module';

@NgModule({
  imports: [
    CommonModule
    ,MainRoutingModule
    ,LayoutModule
    ,routableModules
    ,GrayBarHeaderModule
    ,PrettyJsonModule
  ],
  declarations: [MainComponent],
  exports: [MainComponent]
})
export class MainModule { }

